export const NAV_LINKS = [
    { label: "Ce que je fais", href: "#perimetre" },
    { label: "Pour qui", href: "#pour-qui" },
    { label: "Étapes", href: "#methode" },
    { label: "Situations", href: "#situations" },
    { label: "Qui suis-je", href: "#qui-suis-je" },
];

export const SERVICES = [
    {
        title: "Données personnelles",
        body: "Relire les informations collectées, publiées ou transmises dans le cadre d'une activité.",
    },
    {
        title: "Pratiques numériques",
        body: "Identifier les usages, outils, formulaires, plateformes ou services numériques qui doivent être corrigés ou mieux encadrés.",
    },
    {
        title: "Obligations courantes",
        body: "Vérifier les mentions, justificatifs, documents et points de conformité utiles à une activité professionnelle ou patrimoniale.",
    },
];

export const METHOD = [
    { n: "01", body: "Vous décrivez la situation." },
    { n: "02", body: "Je regarde les informations concernées." },
    {
        n: "03",
        body: "Je distingue ce qui expose réellement de ce qui relève d'un risque théorique.",
    },
    { n: "04", body: "Je vous propose des corrections concrètes." },
];

// Scroll distance in pixels past which the "back to top" button appears.
export const SCROLL_TO_TOP_THRESHOLD = 600;

// Site-wide pause notice. Toggle ACTIVITY_PAUSED to false to remove
// the banner. Texts kept here so they can be edited without touching
// the component.
export const ACTIVITY_PAUSED = true;
export const PAUSE_BANNER_TITLE = "Activité en pause";
export const PAUSE_BANNER_BODY =
    "L'activité Données & Droit est actuellement suspendue à durée indéterminée. Le site reste accessible à titre informatif, mais aucune nouvelle mission, demande d'accompagnement ou prise de contact professionnelle n'est actuellement traitée.";
export const PAUSE_CONTACT_NOTICE =
    "Le formulaire est temporairement désactivé pendant la pause d'activité. Aucune nouvelle demande n'est traitée pour le moment.";
export const PAUSE_CTA_LABEL = "Activité en pause";
